import { Button } from '@yellowcard/components-library-vue3';
import { defineComponent, onMounted } from 'vue';
import { useKycStore } from '@/store/modules/kyc';
import { useAuthStore } from '@/store/modules/auth';
import { storeToRefs } from 'pinia';
import { KycTypes } from '@/types/kyc';
import { MIXPANEL_EVENTS, trackEvent } from '@/utils/mixpanel';
export default defineComponent({
    name: 'CompleteStatus',
    props: {},
    components: { Button },
    setup() {
        const kycStore = useKycStore();
        const { currentStep, idType } = storeToRefs(kycStore);
        const authStore = useAuthStore();
        const { partnerId } = storeToRefs(authStore);
        onMounted(() => {
            trackEvent(MIXPANEL_EVENTS.KYC.EOF, {
                id_type: idType.value,
                partner: partnerId.value,
            });
        });
        const proceed = () => {
            // submit data to be
            trackEvent(MIXPANEL_EVENTS.KYC.CHECK_STATUS, {
                screen: 'KYC EOF Screen',
                partner: partnerId.value,
            });
            currentStep.value = KycTypes.KycSteps.VERIFICATION_STATUS;
        };
        return {
            proceed,
        };
    },
});
